import React from "react";
import "./Skills.css";
import { TiHtml5 } from "react-icons/ti";
import { FaCss3Alt } from "react-icons/fa";
import { FaBootstrap } from "react-icons/fa6";
import { SiMui } from "react-icons/si";
import { FaWordpressSimple } from "react-icons/fa6";
import { FaNode } from "react-icons/fa";
import { IoLogoNodejs } from "react-icons/io";
import { IoLogoJavascript } from "react-icons/io5";
import { SiExpress } from "react-icons/si";
import { DiMysql } from "react-icons/di";
import { SiSequelize } from "react-icons/si";
import { SiMongodb } from "react-icons/si";
import { DiFirebase } from "react-icons/di";
import { FaShopify } from "react-icons/fa6";
import { FaReact } from "react-icons/fa6";
import { SiNextdotjs } from "react-icons/si";

const Skills = () => {
  return (
    <>
      <section className="skillsWrapper">
        <h1>Skills and Expertise:</h1>
        <div className="skillSection frontendSection">
          <span>Frontend: </span>
          <span className="frontendSkills">
            <TiHtml5 style={{ color: "#DD4B25" }} />
            <FaCss3Alt style={{ color: "#254BDD" }} />

            <FaBootstrap style={{ color: "#8411F6" }} />
            <SiMui style={{ color: "#007FFF" }} />
            <IoLogoNodejs
              style={{ color: "#CFB431" }}
              data-tooltip="JavaScript"
            />
            <FaReact style={{ color: "#5ED3F3" }} />
            <SiNextdotjs style={{ color: "#000000" }} />
          </span>
        </div>
        <div className="skillSection">
          <span>Backend: </span>
          <span>
            <FaNode style={{ color: "#87BF00" }} />
            <IoLogoJavascript style={{ color: "black" }} />
            <SiExpress />
          </span>
        </div>
        <div className="skillSection">
          <span>Database: </span>
          <span>
            <DiMysql style={{ color: "#015B85" }} />
            <SiSequelize style={{ color: "#015B85" }} />
            <SiMongodb style={{ color: "#03E461" }} />
            <DiFirebase style={{ color: "#FFCB2D" }} />
          </span>
        </div>
        <div className="skillSection">
          <span>Ecommerce: </span>
          <span>
            <FaShopify style={{ color: "#5C8A3C" }} />
            <FaWordpressSimple style={{ color: "#207196" }} />
          </span>
        </div>
      </section>
    </>
  );
};

export default Skills;
